var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStruk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 10,
    viewBox: "0 0 1920 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 10,
    fill: "url(#paint0_linear_677_3446)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_677_3446",
    x1: 44.5,
    y1: 10,
    x2: 1920,
    y2: 10.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5ED13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41493,
    stopColor: "#7AC57A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00ACED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStruk);
export default __webpack_public_path__ + "static/media/Struk.001a737385e177b44549ca6e6397cc4f.svg";
export { ForwardRef as ReactComponent };